import { render, staticRenderFns } from "./app-select.vue?vue&type=template&id=51df2469"
import script from "./app-select.vue?vue&type=script&lang=ts"
export * from "./app-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51df2469')) {
      api.createRecord('51df2469', component.options)
    } else {
      api.reload('51df2469', component.options)
    }
    module.hot.accept("./app-select.vue?vue&type=template&id=51df2469", function () {
      api.rerender('51df2469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-select/app-select.vue"
export default component.exports